import {FormGroup} from '@angular/forms';

// custom validator to check that two fields match
export function PatternMatch(controlName: string): any {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];

    // set error on matchingControl if validation fails
    let passwordStrength = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})');
    if (control.value === '') {
      control.setErrors({required: true});
    } else if (control.value.length < 8) {
      control.setErrors({minlength: true});
    } else if (!passwordStrength.test(control.value)) {
      control.setErrors({pattern: true});
    }
  };
}
